import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: true,
  cryptoLoading: false,
  error: false,
  transactions: [],
  cryptoTransactions: [],
  reversedTransactions: null,
  loadingReversedTransactions: false,
  transactionDetailsLoading: false,
  transactionDetails: null,
  fiatPayinDetailsLoading: false,
  fiatPayinDetails: null,
  searchResults: null,
  searchResultsCount: 0,
  searching: false,
  searchError: false,
  exporting: false,
  exportResults: "",

  search9PSBResults: null,
  search9PSBResultsCount: 0,
  searching9PSB: false,
  search9PSBError: false,
};

const transactionsSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    getTransactionsList: (state) => {
      state.loading = true;
    },
    getTransactionsListSuccess: (state, action) => {
      state.loading = false;
      state.transactions = action.payload;
    },

    getTransactionsListError: (state, action) => {
      state.loading = false;
      state.transactions = null;
    },

    getCryptoTransactionsList: (state) => {
      state.cryptoLoading = true;
    },
    getCryptoTransactionsListSuccess: (state, action) => {
      state.cryptoLoading = false;
      state.cryptoTransactions = action.payload;
    },

    getCryptoTransactionsListError: (state, action) => {
      state.cryptoLoading = false;
      state.cryptoTransactions = null;
    },
    getReversedTransactionsList: (state) => {
      state.loadingReversedTransactions = true;
    },
    getReversedTransactionsListSuccess: (state, action) => {
      state.loadingReversedTransactions = false;
      state.reversedTransactions = action.payload;
    },

    getReversedTransactionsListError: (state) => {
      state.loadingReversedTransactions = false;
    },
    resetReversedTransactionsList: (state) => {
      state.loadingReversedTransactions = true;
    },
    resetTransactionsList: (state) => {
      state.loading = true;
    },
    getTransactionDetails: (state) => {
      state.transactionDetailsLoading = true;
      state.transactionDetails = null;
    },
    getTransactionDetailsSuccess: (state, action) => {
      state.transactionDetailsLoading = false;
      state.transactionDetails = action.payload;
    },
    getTransactionDetailsError: (state, action) => {
      state.transactionDetailsLoading = false;
      state.transactionDetails = null;
    },
    getFiatPayinDetails: (state) => {
      state.fiatPayinDetailsLoading = true;
      state.fiatPayinDetails = null;
    },
    getFiatPayinDetailsSuccess: (state, action) => {
      state.fiatPayinDetailsLoading = false;
      state.fiatPayinDetails = action.payload;
    },
    getFiatPayinDetailsError: (state) => {
      state.fiatPayinDetailsLoading = false;
      state.fiatPayinDetails = null;
    },
    searchTransactions: (state) => {
      state.searching = true;
    },
    searchTransactionsError: (state) => {
      state.searching = false;
      state.searchError = true;
      state.searchResults = null;
    },

    searchTransactionsSuccess: (state, action) => {
      state.searching = false;
      state.searchError = false;
      state.searchResults = action.payload?.data;
      state.searchResultsCount = action.payload?.count;
    },

    search9PSBTransactions: (state) => {
      state.searching9PSB = true;
    },
    search9PSBTransactionsError: (state) => {
      state.searching9PSB = false;
      state.search9PSBError = true;
      state.search9PSBResults = null;
    },

    search9PSBTransactionsSuccess: (state, action) => {
      state.searching9PSB = false;
      state.search9PSBError = false;
      state.search9PSBResults = [action.payload?.data];
      state.search9PSBResultsCount = action.payload?.count || 1;
    },

    exportAccountTransactions: (state) => {
      state.exporting = true;
      state.exportResults = "";
    },
    exportAccountTransactionsSuccess: (state, action) => {
      state.exporting = false;
      state.exportResults = action.payload;
    },
    exportAccountTransactionsError: (state, action) => {
      state.exporting = false;
      state.exportResults = "";
    },
    resetExportAccountTransactions: (state) => {
      state.exporting = false;
      state.exportResults = "";
    },
    resetSearchState: (state) => {
      state.searching = false;
      state.searchError = false;
      state.searchResults = null;
      state.searching9PSB = false;
      state.search9PSBError = false;
    },
    resetTransactionDetails: (state) => {
      state.transactionDetails = null;
      state.searchResults = null;
      state.searching9PSB = false;
      state.search9PSBError = false;
    },
  },
});

export default transactionsSlice;
